module.exports = __webpack_public_path__ + "img/HC1002-02.22716422.jpg";